import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function TimeComparison() {
  const tasks = [
    {
      task: 'Interviewer Research',
      manualTime: '2 Hours per Interviewer',
      aiTime: '1 Minute'
    },
    {
      task: 'Company Research',
      manualTime: '2 Hours',
      aiTime: '1 Minute'
    },
    {
      task: 'Company Competitor Research',
      manualTime: '3 Hours',
      aiTime: '1 Minute'
    },
    {
      task: 'Top 20 Question Customization',
      manualTime: '3 Hours per Interviewer',
      aiTime: '1 Minute'
    },
    {
      task: 'Interview Prep Best Practices',
      manualTime: '3 Hours',
      aiTime: '1 Minute'
    },
  ];

  return (
    <section className="py-10 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold sm:text-5xl md:text-6xl text-center mb-12">
            Great interview skills shouldn't
            <span className="text-blue-500"> cost you hours</span>
          </h2>

          <div className="rounded-2xl overflow-hidden">
            {/* Header */}
            <div className="grid grid-cols-3">
              <div className="p-6"></div>
              <div className="p-6 text-xl font-semibold text-center bg-black text-white rounded-tl-2xl">
                By Yourself
              </div>
              <div className="p-6 text-xl font-semibold text-center bg-black text-white">
                With Us
              </div>
            </div>

            {/* Content */}
            {tasks.map((item, index) => (
              <div key={index} className="grid grid-cols-3 border-b border-purple-100">
                <div className="p-6 font-medium text-gray-900 bg-gray-50">{item.task}</div>
                <div className="p-6 text-center bg-gray-100 text-gray-900">{item.manualTime}</div>
                <div className="p-6 text-center bg-blue-500 text-white flex items-center justify-center gap-2">
                  <ArrowRight className="w-4 h-4" />
                  {item.aiTime}
                </div>
              </div>
            ))}

            {/* Footer */}
            <div className="grid grid-cols-3">
              <div className="p-8 bg-white"></div>
              <div className="p-8 text-center bg-gray-100 rounded-bl-2xl">
                <div className="text-4xl font-bold">13+</div>
                <div className="">Hours</div>
                <div className="text-sm  mt-2">
                  Let's be honest, you'd never get this done anyway. (You know it's true, because you haven't...)
                </div>
              </div>
              <div className="p-8 text-center bg-blue-500 text-white">
                <div className="text-4xl font-bold">5</div>
                <div>Minutes</div>
                <div className="text-sm text-white mt-2">
                  Yes, we timed it — How much would you pay to get 12 hours and 55 minutes back and a job offer?
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}